import React from "react";
import WhoIsMyrtleHeader from "./WhoIsMyrtleHeader";
import WhoIsMyrtle from "./WhoIsMyrtle";

const MainWhoandWhy = () => {
  return (
    <div>
      <WhoIsMyrtleHeader />
      <WhoIsMyrtle />={" "}
    </div>
  );
};

export default MainWhoandWhy;
